import { AlertTriangle } from 'lucide-react';
import type { ReportDataWarning } from '../lib/generated-report';

const SOURCE_LABELS: Record<ReportDataWarning['source'], string> = {
  master: 'Master',
  mail: 'Mail',
  responses: 'Risposte',
  configuration: 'Configurazione',
  mixed: 'Più sorgenti',
};

export function ReportDataWarnings({ warnings }: { warnings?: ReportDataWarning[] }) {
  if (!warnings?.length) return null;

  return (
    <section className="report-data-warnings" role="status" aria-label="Avvisi sulla completezza dei dati">
      <div className="report-data-warnings-icon"><AlertTriangle size={20} /></div>
      <div className="report-data-warnings-content">
        <div className="report-data-warnings-heading">
          <strong>Dati sorgente da verificare</strong>
          <span>{warnings.length} {warnings.length === 1 ? 'avviso' : 'avvisi'}</span>
        </div>
        <ul>
          {warnings.map((warning) => (
            <li key={warning.code}>
              <span>{SOURCE_LABELS[warning.source]}</span>
              <div><strong>{warning.title}</strong><p>{warning.message}</p></div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
